<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-11 15:40:02
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-17 11:16:42
 * @Description: 借款协议
 -->

<template>
  <div class="loan-agreement-wrapper">
    <!-- <h2 class="title">借款协议</h2>
    <p>编号：</p> -->
    <iframe
      src="https://jydpro.jinr.com/uploadsFiles/jyd/static/agreement.pdf"
      frameborder="0"
      class="pdf-wrapper"
    ></iframe>
    <div class="btn" @click="handleClick">返回</div>
  </div>
</template>
<script>
export default {
  name: 'loan-agreement',
  methods: {
    handleClick() {
      this.$router.back();
    }
  }
};
</script>
<style lang="less" scoped>
.loan-agreement-wrapper {
  padding: 40px;
  background: #ffffff;
  .pdf-wrapper {
    width: 100%;
    height: 800px;
  }
  h2 {
    text-align: center;
    font-size: 26px;
    font-weight: 600;
    line-height: 40px;
  }
  p {
    margin: 10px;
    text-indent: 2em;
  }
  .bold {
    font-weight: 700;
  }
  .btn {
    background: #2c6eff;
    color: #ffffff;
    font-size: 20px;
    width: 200px;
    height: 40px;
    margin: 20px auto 0;
    border-radius: 8px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}
</style>
